import * as React from 'react'
import { Droplet } from 'react-feather'

import { Strong, Text } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'

import Bullet from '../common/Bullet'
import { i18nKeyPrefix } from '../i18n'

const PRE = `${i18nKeyPrefix}-BASICS-POTTY-TRAINING`

interface IProps {
  pottyTrainingRequired: boolean | null
}

export default function PottyTraining(props: IProps) {
  const { pottyTrainingRequired } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  if (pottyTrainingRequired === null) return null

  return (
    <Bullet icon={<Droplet />}>
      <Strong>{t(`${PRE}-TEXT`)}</Strong>
      <Text muted>{pottyTrainingRequired ? t(`${PRE}-REQUIRED`) : t(`${PRE}-NOT-REQUIRED`)}</Text>
    </Bullet>
  )
}
